import { Wrapper } from 'components'

import './admin-content.scss'

export default Wrapper( 'admin-content' )
